var t = /* @__PURE__ */ ((e) => (e.SINGLE_LINE = "single-line", e.MULTI_LINE = "multi-line", e.PASSWORD = "password", e.EDITABLE_TEXT = "editable-text", e.DATE = "date", e))(t || {});
export {
  t as TEXT_INPUT_VARIANTS
};
//# sourceMappingURL=text-input-variants.js.map
